import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataSourceDirective, DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { CampaignsListItemComponent } from './campaigns-list-item/campaigns-list-item.component';
import { CampaignsOffersListComponent } from './campaigns-offers-list/campaigns-offers-list.component';
import { CampaignsOffersUsedListItemComponent } from './campaigns-offers-used-list-item/campaigns-offers-used-list-item.component';
import { CampaignsOffersUsedListComponent } from './campaigns-offers-used-list/campaigns-offers-used-list.component';

@NgModule({
  declarations: [
    CampaignsOffersUsedListComponent,
    CampaignsOffersUsedListItemComponent,
    CampaignsOffersListComponent,
    CampaignsListItemComponent,
  ],

  imports: [
    DataSourceDirective,
    CommonModule,
    NgbModule,
    PipesModule,
    CarouselModule,
    LoadingModule,
    RouterModule,
    DirectivesModule,
    FormsModule,
    FGBSharedModule,
  ],
  exports: [
    CampaignsOffersUsedListComponent,
    CampaignsOffersUsedListItemComponent,
    CampaignsOffersListComponent,
    CampaignsListItemComponent,
  ],
})
export class CampaignsModule {}
